import { useEffect, useRef, useState } from 'react';

import { clearQueryParamSilently, getQueryParam } from '@cast/utils';

export const CREATE_ALERT_ACTION_KEY = 'action';
export const CREATE_ALERT_ACTION_VALUE = 'create-alert';
export const MANAGE_ALERTS_ACTION_VALUE = 'manage-alerts';

export const useNavigateToCreateAlert = (
  onAction: () => void,
  canCreate: boolean
) => {
  const [action, setAction] = useState<string | null>(() =>
    getQueryParam(CREATE_ALERT_ACTION_KEY)
  );
  const onActionRef = useRef(onAction);

  useEffect(() => {
    if (action === CREATE_ALERT_ACTION_VALUE && canCreate) {
      setAction(null);
      clearQueryParamSilently(CREATE_ALERT_ACTION_KEY);
      onActionRef.current();
    }
  }, [action, canCreate]);
};

export const useNavigateToManageAlerts = (
  onAction: () => void,
  canCreate: boolean
) => {
  const [action, setAction] = useState<string | null>(() =>
    getQueryParam(CREATE_ALERT_ACTION_KEY)
  );
  const onActionRef = useRef(onAction);

  useEffect(() => {
    if (action === MANAGE_ALERTS_ACTION_VALUE && canCreate) {
      setAction(null);
      clearQueryParamSilently(CREATE_ALERT_ACTION_KEY);
      onActionRef.current();
    }
  }, [action, canCreate]);
};
